"use client";

import { useConfig } from "@stadium/hooks/lib/use-config";

import FeaturedShopSection from "@components/widgets/featured-shop-explore-section";

import { getDefaultShopNumber } from "@selectors/config";

import styles from "./main.module.scss";

export const GIFT_CATALOG_CONTENT = {
  buttonText: "BROWSE ALL PRODUCTS",
};

const GiftCatalog = (props) => {
  const defaultShopNumber = useConfig(getDefaultShopNumber);
  return (
    <div className={styles.giftCatalogContainer}>
      <FeaturedShopSection
        content={GIFT_CATALOG_CONTENT}
        storeNumber={defaultShopNumber}
        styles={styles}
        checkForSwag
        {...props}
      />
    </div>
  );
};

export default GiftCatalog;
